export default function formatPriceCent(priceCent: number): string {
  const price = priceCent / 100;
  return price.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
